export enum CarouselLayout {
	CAROUSEL = 'carousel',
	FLAT = 'flat',
}
